.root {
  background-image: linear-gradient(90deg,
      color-mix(in srgb, var(--mantine-color-pachubColourScheme-0), transparent 0%) 0%,
      color-mix(in srgb, var(--mantine-color-gray-0), transparent 25%) 75%,
      color-mix(in srgb, var(--mantine-color-pachubColourScheme-1), transparent 25%) 100%),
    url('/element5-digital-OyCl7Y4y0Bk-unsplash.jpg');
  background-size: cover;
  background-position: right bottom;
  padding-top: calc(var(--mantine-spacing-xl));
  padding-bottom: calc(var(--mantine-spacing-xl));
  border-bottom: 1px solid var(--mantine-color-gray-2);
}

.inner {
  display: flex;
  justify-content: flex-start;
  align-items: center;
  backdrop-filter: initial;
}

.content {
  max-width: 640px;
}

.title {
  color: var(--mantine-color-pachubColourScheme-8);
  font-weight: 800;
  line-height: 1.15;
  font-size: clamp(2rem, 5vw, 2.75rem);
  white-space: pre-line;
}

.description {
  color: var(--mantine-color-gray-8);
  font-size: var(--mantine-font-size-lg);
  font-weight: 500;
  line-height: 1.6;
  max-width: 560px;
}